import styled from 'styled-components'
import Image from 'next/image'
import dynamic from 'next/dynamic'

const Video = dynamic(() => import('../Video'), { ssr: false })

export const AdsDescription = styled.div``

export const MainImage = styled(Image)`
  max-height: 41.1rem;
  width: auto;
  max-width: 100%;
`

export const MainVideo = styled(Video)``

export const Title = styled.h2`
  ${({ theme }) => theme.textStyles.firaSans2XlBold};
  color: ${({ theme }) => theme.colors.bluePrimary};
  margin: 2rem 0;
`

export const Text = styled.p`
  ${({ theme }) => theme.textStyles.montserratTextBase};
`
